exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-328af3ca]{margin-bottom:20px}p[data-v-328af3ca]{font-size:1.7vmax}", ""]);

// exports
